import { axiosInstance } from "./config";


export const getAllTypes = async () => {
  const res = await axiosInstance.get('/types');
  return res.data;
};

export const createType = async (data) => {
  const res = await axiosInstance.post('/types', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data;
};

export const updateType = async (id, data) => {
  const res = await axiosInstance.put(`/types/${id}`, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return res.data;
};

export const deleteType = async (id) => {
  const res = await axiosInstance.delete(`/types/${id}`);
  return res.data;
};
